// ***************************************
// Definition of game token ExplosionToken
// ***************************************
import { tbGame } from "../engine/tbGame";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { EffectsSettings } from "../settings/Settings";
import { s_tnt } from "./AssetDefinitions/SpineDefinitions";
import { ExplosionParticle } from "./ExplosionParticle";
import { getContainerForLayer, Layer } from "./SceneController";
// The constructor for the ExplosionToken game token.
export var ExplosionToken = function (x, y) {
    "use strict";
    // Properties used by the engine
    this.animation = s_tnt.clone();
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.x = x;
    this.y = y;
    this.container = getContainerForLayer(Layer.explosion);
    this.exploded = false;
    this.timeRemove = 0;
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
ExplosionToken.prototype.handleAdd = function () {
    "use strict";
    var self = this;
    var scale = (1 / PhysicsSettings.textureResolution) * EffectsSettings.explosionScaleFactor;
    this.animation.setAnimation("explosion", false);
    this.animation.setScale((scale * PhysicsSettings.extraTextureScale) * 2);
    this.animation.setPosition(this.x, this.y);
    this.animation.setOnComplete(function () {
        // self.animation.setAnimation("explosion", false);
        // self.animation.setOnComplete(function(){
        self.exploded = true;
        // });
    });
    this.container.addChild(this.animation);
    new ExplosionParticle(this.x, this.y, this.container);
};
// handleRemove is called when the token is removed from the game.
ExplosionToken.prototype.handleRemove = function () {
    "use strict";
    this.container.removeChild(this.animation);
    this.animation.free();
    this.animation = null;
};
// handleBeginStep is called each step before processing other events.
ExplosionToken.prototype.handleBeginStep = function (timePassed) {
    "use strict";
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
ExplosionToken.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
ExplosionToken.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
ExplosionToken.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
ExplosionToken.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
ExplosionToken.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (!this.exploded) {
        return;
    }
    else {
        this.timeRemove -= timePassed;
    }
    if (this.timeRemove <= 0) {
        tbGame.removeToken(this);
    }
};
// handleDraw is called at the end of a step to draw the token.
ExplosionToken.prototype.handleDraw = function () {
    "use strict";
};
